import { getInitialState, getPath } from "../../utils";

const initialState = {
  callDepartmentsList: [],
  currentPage: 1,
  prevPage: -1,
  nextPage: -1,
  activeObject: {},
  activeFilters: {},
  languageRemoteSearch: {
    languages: [],
    nextPage: -1,
    prevPage: -1,
    currentPage: 1,
  },
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CALL_DEPARTMENTS_LIST": {
      return setCallDepartmentList(state, action);
    }
    case "SET_CALL_DEPARTMENTS_ACTIVE_OBJECT": {
      return setCallDepartmentActiveObject(state, action);
    }
    case "SET_CALL_DEPARTMENTS_ACTIVE_FILTERS": {
      return setCallDepartmentActiveFilters(state, action);
    }
    case "SET_CALL_DEPARTMENTS_LANGUAGE_REMOTE_SEARCH": {
      return setCallDepartmentLanguageRemoteSearch(state, action);
    }
    case "SET_CALL_DEPARTMENT_CURRENT_PAGE": {
      return setCallDepartmentCurrentPage(state, action);
    }
    default: {
      return state;
    }
  }
}

const setCallDepartmentList = (state, action) => {
  return {
    ...state,
    callDepartmentsList: getPath(action.payload, "departments", []),
    prevPage: state.currentPage === 1 ? -1 : state.currentPage - 1,
    nextPage: getPath(action.payload, "hasNext", false)
      ? state.currentPage + 1
      : -1,
  };
};
const setCallDepartmentActiveObject = (state, action) => {
  return {
    ...state,
    activeObject: action.payload,
  };
};
const setCallDepartmentActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setCallDepartmentLanguageRemoteSearch = (state, action) => {
  return {
    ...state,
    languageRemoteSearch: {
      languages: getPath(action.payload, "data", []),
      nextPage: getPath(action.payload, "hasNext", false)
        ? state.languageRemoteSearch.currentPage + 1
        : -1,
      prevPage:
        state.languageRemoteSearch.currentPage === 1
          ? -1
          : state.languageRemoteSearch.currentPage - 1,
    },
  };
};

const setCallDepartmentCurrentPage = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};
